// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"91e31454e3c9389c","835":"12f2bfcb9226cf69","898":"fd8bfa2092c915b5","983":"b7384beaef556127"}[chunkId] + ".js";
};